
// **  Initial State
const initialState = {
  data: [],
}

const activityReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'CASH_DRAWER_ACTIVITY_REPORT':
      return {
        ...state,
        data: action.payload,
      }
    default:
      return state
  }
}

export default activityReducer
